/* ===========================================================================
   ROSSI — Mulberry protection cart fix
   ---------------------------------------------------------------------------
   PROBLEM: On v2 PDPs the ATC bridge (rossi-upgrade.js -> rossiAjaxAddToCart)
   listens on document(capture) and calls stopImmediatePropagation(), which
   preempts the Mulberry widget's own ATC handler. Result: a selected
   protection plan was NEVER added to the cart (verified — cart had the product
   only, no _mulberry line, despite the "+ $X" shown on the ATC button).

   FIX: a window(capture) click listener. Window-capture ALWAYS fires before
   any document-capture listener (DOM event path: window -> document -> ...),
   regardless of script load order, so this runs BEFORE the bridge. If a
   protection plan is selected, it adds the warranty line FIRST via a
   SYNCHRONOUS /cart/add.js POST. Because the add is synchronous, it completes
   before the bridge proceeds to add the product + open the cart drawer, so the
   drawer renders BOTH lines.

   It does NOT preventDefault / stopPropagation — the bridge still runs and
   handles the product add + drawer exactly as before, and still suppresses the
   official Mulberry adapter. If the warranty add fails, the error is swallowed
   and the bridge adds the product anyway, so cart-add can never regress below
   product-only behavior.
   =========================================================================== */
(function rossiMulberryCartFix() {
  'use strict';

  var lastAddAt = 0;
  var DEBOUNCE_MS = 1500; // matches the ATC bridge's idempotency window

  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.rossi-btn--atc');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var widget = document.getElementById('mulberry-pdp-widget');
    if (!widget) return;

    var selected = widget.querySelector('.mulberry-pdp__plan.is-selected');
    if (!selected || !selected.dataset.planType || selected.dataset.planType === 'none') return;

    var slot = widget.querySelector('[data-price-slot="' + selected.dataset.planType + '"]');
    var warrantyVariantId = slot && slot.dataset.variantId;
    if (!warrantyVariantId) return;

    var now = Date.now();
    if (now - lastAddAt < DEBOUNCE_MS) return;
    lastAddAt = now;

    var form = btn.getAttribute('form')
      ? document.getElementById(btn.getAttribute('form'))
      : (btn.closest && btn.closest('form[action*="/cart/add"]'));

    var qtyEl = form && form.querySelector('.product-form__quantity input.product-form__input--quantity');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

    var idField = form && form.querySelector('[name="id"]');
    var coveredVariantId = (idField && idField.value) || widget.dataset.variantId || '';

    /* Synchronous add: guarantees the warranty line is in the cart before the
       ATC bridge (which runs next, on document-capture) adds the product and
       opens the drawer — so the drawer renders both lines. */
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', false);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({
        id: warrantyVariantId,
        quantity: qty,
        properties: {
          _mulberry: 'true',
          _covered_product: widget.dataset.productTitle || '',
          _covered_product_id: widget.dataset.productId || '',
          _covered_variant_id: coveredVariantId
        }
      }));
    } catch (err) {
      /* Swallow — the bridge still adds the product, so no regression. */
      try { console.error('[Rossi/Mulberry] warranty add failed:', err); } catch (e) {}
    }
    /* Intentionally NO preventDefault / stopPropagation — let the bridge run. */
  }, true); // window capture — fires before the document-capture ATC bridge
})();
